import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export const useGlobalSearch = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();
    const location = useLocation();

    const handleSearch = (term: string) => {
        if (!term.trim()) return;

        // If we're already on the catalog page, update URL params
        if (location.pathname === '/catalog') {
            const params = new URLSearchParams(location.search);
            params.set('search', term);
            params.delete('page'); // Reset to first page
            navigate(`/catalog?${params.toString()}`);
        } else {
            // Navigate to catalog with search term
            navigate(`/catalog?search=${encodeURIComponent(term)}`);
        }
    };

    const clearSearch = () => {
        setSearchTerm('');
        if (location.pathname === '/catalog') {
            const params = new URLSearchParams(location.search);
            params.delete('search');
            params.delete('page');
            const newSearch = params.toString();
            navigate(`/catalog${newSearch ? `?${newSearch}` : ''}`);
        }
    };

    return {
        searchTerm,
        setSearchTerm,
        handleSearch,
        clearSearch
    };
};
